import React from "react";

import "./wearables-v2.css";

type Props = {
  passive?: boolean;
  children: React.ReactNode;
};

export default function WearablesInlineSignal({
  passive = false,
  children,
}: Props): JSX.Element {
  return (
    <section
      className={`st-wearables-v2-inline ${passive ? "st-wearables-v2-inline--passive" : ""}`}
      aria-live="polite"
    >
      {children}
    </section>
  );
}